import { http, HttpResponse } from "msw";
import { PlessService } from "src/app/shared/pless-service.model";

// KYMW7402 忘れず注文商品商品登録
export const kymw7402Handlers = [
  http.post(
    PlessService.SERVICE.getGoodsCoopByItemCode.url,
    async ({ request }) => {
      const req = await request.json();
      return HttpResponse.json(getGoodsCoopByItemCode);
      // return ResponseUtils.getSysError();
      // return ResponseUtils.getE0100();
    }
  ),
  http.post(
    PlessService.SERVICE.getFixedOrderList.url,
    async ({ request }) => {
      const req = await request.json();
      return HttpResponse.json(getFixedOrderList);
      // return ResponseUtils.getSysError();
      // return ResponseUtils.getE0100();
    }
  ),
  http.post(
    PlessService.SERVICE.getRememberGoodsInfo.url,
    async ({ request }) => {
      const req = await request.json();
      return HttpResponse.json(getRememberGoodsInfo);
    }
  ),
  http.post(
    PlessService.SERVICE.getRememberOrderNum.url,
    async ({ request }) => {
      const req = await request.json();
      return HttpResponse.json(getRememberOrderNum);
      // return ResponseUtils.getSysError();
      // return ResponseUtils.getE0100();
      // return ResponseUtils.get500();
    }
  ),
  http.post(
    PlessService.SERVICE.updateRememberGoodsInfo.url,
    async ({ request }) => {
      const req = await request.json();
      return HttpResponse.json(updateRememberGoodsInfo);
    }
  ),
  http.post(
    PlessService.SERVICE.updateRememberGoodsInfoForFixed.url,
    async ({ request }) => {
      const req = await request.json();
      return HttpResponse.json(updateRememberGoodsInfoForFixed);
    }
  ),
];

const getGoodsCoopByItemCode = {
  status: "ok",
  message: "処理完了",
  result: {
    obj: {
      CoopCodeList: [
        "142",
        "163",
        "185",
        "240",
        "210",
        // "302",
        // "515",
        // "451",
        // "454"
      ]
    }
  }
}

const getFixedOrderList = {
  status: "ok",
  message: "処理完了",
  result: {
    obj: [
      {
        OrderCode: "2023160",
        CatalogId: "20230701",
        RegistCycle: "Ｄ週"
      },
      {
        OrderCode: "2023170",
        CatalogId: "20230702",
        RegistCycle: "Ａ週"
      },
      {
        OrderCode: "2023180",
        CatalogId: "20230703",
        RegistCycle: "Ｂ週"
      }
    ]
  }
}

const getRememberGoodsInfo = {
  status: "ok",
  message: "処理完了",
  result: {
    obj: {
      RememberGoodsId: "00000001",
      RememberGoodsStatus: "2",   //忘れず注文商品ステータスが承認済みの場合
      // RememberGoodsStatus: "",
      ItemCode: "0004383",
      MasterPrice: "560",
      GuideGoodsName: "０１２３４５６７８９０１２３４５６７８９０１２３４５６７８９",
      GuideStandardName: "０１２３４５６７８９０１２３４５６７８９",
      OrderNum: "000001",
      OrderChangeOrderNum: "000011",
      IncreaseGoods: "1",
      RememberCategoryCode: "090001000",
      // OrderReceptionStartCatalog: "20231001",
      // OrderReceptionStartCatalog: "20230701",   // 受注受付開始企画回 企画確定の時
      OrderReceptionStartCatalog: "20230801", 
      OrderReceptionEndCatalog: "20231003",
      DeliveryStartCatalog: "20231001",
      DeliveryEndCatalog: "20241001",
      // DeliveryEndCatalog: "20230703",           // 配達終了企画回　企画確定
      DeliveryCycleDiv: "21",
      // DeliveryCycleDiv: "41",                   // 配達サイクル区分 １ヶ月毎
      MonthlyDeliveryTimes: "4",
      GoodsCatalogDiv: "1",
      PauseGroupCode: "A",
      CoopCodeList: [
        "142",
        "163",
        "185",
        // "240",
        "210",
        // "302",
        // "515",
        // "451",
        // "454"
      ],
      DetailInfoList: [
        {
          ApplicableStartCatalog: "20230701", // 開始も終了も企画確定している
          ApplicableEndCatalog: "20230702",
          PauseDelivery: "1",
          DiscountType: "2",
          DiscountUnitPrice: "",
          DiscountRate: "10",
          RememberGoodsName: "忘れず注文たまご２",
          RememberGoodsNameKana: "ﾀﾏｺﾞ2",
          RememberStandardName: "14個入",
          RememberStandardNameKana: "14ｺｲﾘ"
        },
        // {
        //   ApplicableStartCatalog: "20231101",
        //   ApplicableEndCatalog: "20231002", // 適用終了企画回　適用開始企画回と適用終了企画回が逆転している場合(FromTo不整合)
        //   PauseDelivery: "0",
        //   DiscountType: "1",
        //   DiscountUnitPrice: "99",
        //   DiscountRate: "",
        //   RememberGoodsName: "忘れず注文たまご",
        //   RememberGoodsNameKana: "ﾀﾏｺﾞ",
        //   RememberStandardName: "12個入",
        //   RememberStandardNameKana: "12ｺｲﾘ"
        // },
        // {
        //   ApplicableStartCatalog: "20231001", // 更新時、適用開始企画回 前行の企画回と連続していない
        //   ApplicableEndCatalog: "20231002",
        //   PauseDelivery: "0",
        //   DiscountType: "1",
        //   DiscountUnitPrice: "99",
        //   DiscountRate: "",
        //   RememberGoodsName: "忘れず注文たまご",
        //   RememberGoodsNameKana: "ﾀﾏｺﾞ",
        //   RememberStandardName: "12個入",
        //   RememberStandardNameKana: "12ｺｲﾘ"
        // },
        {
          ApplicableStartCatalog: "20230703", // 開始だけ企画確定している
          ApplicableEndCatalog: "20230704",
          PauseDelivery: "0",
          DiscountType: "1",
          DiscountUnitPrice: "99",
          DiscountRate: "",
          RememberGoodsName: "忘れず注文たまご",
          RememberGoodsNameKana: "ﾀﾏｺﾞ",
          RememberStandardName: "12個入",
          RememberStandardNameKana: "12ｺｲﾘ"
        },
        {
          ApplicableStartCatalog: "20230705",    // 開始も終了も企画確定していない
          ApplicableEndCatalog: "20230706",
          PauseDelivery: "0",
          DiscountType: "1",
          DiscountUnitPrice: "99",
          DiscountRate: "",
          RememberGoodsName: "忘れず注文たまご",
          RememberGoodsNameKana: "ﾀﾏｺﾞ",
          RememberStandardName: "12個入",
          RememberStandardNameKana: "12ｺｲﾘ"
        },
      ]
    }
  }
}

const getRememberOrderNum = {
  status: "ok",
  message: "処理完了",
  result: {
    obj: {
      OrderNum: "000001", 
      OrderChangeOrderNum: "000002"
    }
  }
}

const updateRememberGoodsInfo = {
  status: "ok",
  message: "処理完了"
}

const updateRememberGoodsInfoForFixed = {
  status: "ok",
  message: "処理完了"
}